<template>
  <div class="wh100">
    <LayoutTopFilter
        style="background: #fffff"
        content-class="custom-content"
    >
      <template slot="filter">
        <el-form :inline="true" :model="form" size="mini" class="filter-form">

          <el-form-item>
            <el-radio-group v-model="form.dateType" @change="dateTypeChange" text-color="#239FF6">
              <el-radio-button label="minute">分钟</el-radio-button>
              <el-radio-button label="hour">小时</el-radio-button>
              <el-radio-button label="day">日</el-radio-button>
              <el-radio-button label="month">月</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-date-picker
                v-model="form.startTime"
                :type="dateType"
                placeholder="选择日期"
                :value-format="dateFormat"
                @change="loadData"
                :key="timeKey"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker
                v-model="form.endTime"
                :type="dateType"
                placeholder="选择日期"
                :value-format="dateFormat"
                @change="loadData"
                :key="timeKey"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select v-model="channelIds" multiple collapse-tags   @change="channelChange">
              <el-option
                  v-for="item in channelList"
                  :value="item.channelId"
                  :label="item.channelName"
                  :key="item.channelId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
          ><el-tooltip content="查询" placement="top">
            <el-button
                icon="el-icon-search"
                type="primary"
                size="mini"
                @click="loadData"
            >查询</el-button
            ></el-tooltip
          >
          </el-form-item>
          <el-form-item>
            <el-button
                icon="el-icon-download"
                type="primary"
                size="mini"
                @click="exportExcel"
            >导出</el-button
            >
          </el-form-item>
        </el-form>
      </template>

      <template slot="content">
        <MyPannel>
          <div class="container" ref="container">
            <MyTable
                ref="mytable"
                id="mytable"
                border
                :url="table.url"
                :method="table.method"
                :params="form"
                index-column
                custom-sort
                stripe
                fit
                :default-sort = "{prop: 'time', order: 'descending'}"
                :autoLoad="isAuto"
                :header-cell-style="getHeaderCellStyle"
            >
              <template slot="columns">
                <!-- <el-table-column
                    prop="stationName"
                    :label="stationLabelName"
                    align="center"
                    width="150"
                    show-overflow-tooltip
                >
                </el-table-column> -->
                <el-table-column
                    prop="stationCode"
                    :label="stationLabelName+'编码'"
                    align="center"
                    width="200"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="time"
                    label="数据时间"
                    align="center"
                    width="140"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    min-width="75"
                    align="center"
                    v-for="item in curChannelList"
                    :key="item.channelId"
                    :label="item.channelName !== 'AQI' ?item.channelName + '\n(' + item.channelUnit + ')' :item.channelName"
                    :prop="item.prop"
                >
                </el-table-column>
              </template>
            </MyTable>
          </div>
        </MyPannel>
      </template>
    </LayoutTopFilter>
  </div>
</template>

<script>
import LayoutTopFilter from "@/components/layout/LayoutTopFilter";
import MyPannel from "@/components/Pannel/Pannel";
import MyTable from "@/components/PageTable";
import MonthDay24HourChart from "@/views/PollutionDistribution/components/MonthDay24HourChart";

export default {
  components: {
    LayoutTopFilter,
    MyPannel,
    MyTable,
    MonthDay24HourChart,
  },
  props: {
    stationId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      stationLabelName: this.$store.state.loginInfo.aliasName ? this.$store.state.loginInfo.aliasName : "站点",
      isAuto:true,
      dateType: "datetime",
      dateFormat: "yyyy-MM-dd HH:mm:ss",
      timeFormat:"yyyy-MM-dd 00:00:00",
      table: {
        method: "POST",
        url: "/analysis/getHistoryStatistic",
        Selection: [],
      },
      form: {
        dateType: "hour",
        startTime: this.$util.formatDate24(
            new Date(new Date().getTime()),
            "yyyy-MM-dd 00:00:00"
        ),
        endTime: this.$util.formatDate24(
            new Date(new Date().getTime()),
            "yyyy-MM-dd HH:00:00"
        ),
        stationIds: this.stationId?[this.stationId]:[],
        anyDateType: "anyMiute",
        treePath: this.$store.state.loginInfo.treePath,
      },
      channelList: [],
      tableHeight: null,
      tableData: [],
      apiColorList: [],
      timeKey:false,
      channelIds:[],
      curChannelList:[],
    };
  },
  methods: {
    //初始化颜色数组
    loadAllApiColor() {
      let _this = this;
      _this.$api.get("/analysis/getAqiRangeColor", { channelId: "" }, function(
          res
      ) {
        if (res.code === "0000") {
          _this.apiColorList = res.data;
        }
      });
    },
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      let color = "#FFFFFF";
      let fontColor = "";
      let filter = [];
      if (column.property === "pm10" || column.property === "pm25") {

        if (columnIndex > 2) {
          this.channelList.forEach((item) => {
            if (item.channelMap.indexOf("_") != -1) {
              item.channelMap1 = item.channelMap.split("_")[0].toLowerCase();
            } else {
              item.channelMap1 = item.channelMap.toLowerCase();
            }
          });

          var channel = this.channelList.filter(
              (e) => e.channelMap1 === column.property
          );
          filter = this.apiColorList.filter(
              (e) => e.channelId === channel[0].channelId
          );
        }
        if (columnIndex > 2 && column.label && filter.length > 0) {
          for (let key in row) {
            if ((row[key] || row[key] == 0) && column.property === key) {
              for (let item of filter) {
                if (item.upperValue != null) {
                  if (
                      row[key] >= item.lowerValue &&
                      row[key] <= item.upperValue
                  ) {
                    color = item.colorValue;
                    fontColor = item.foregroundColor;
                    return `background:${color};color:${fontColor};`;
                  }
                } else if (row[key] >= item.lowerValue) {
                  color = item.colorValue;
                  fontColor = item.foregroundColor;
                  return `background:${color};color:${fontColor};`;
                }
              }
            }
          }
        }
      }
    },
    //求和求平均数的方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "平均值";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr / data.length;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
    dateTypeChange() {
      this.timeKey = !this.timeKey;
      switch (this.form.dateType) {
        case "hour":
          this.getBaseChannelList(14);
          this.dateType = "datetime";
          this.dateFormat = "yyyy-MM-dd HH:00:00";
          this.initDateTime("yyyy-MM-dd HH:00:00");
          break;
        case "day":
          this.getBaseChannelList(9);
          this.dateType = "date";
          this.dateFormat = "yyyy-MM-dd HH:mm:ss";
          this.initDateTime("yyyy-MM-dd HH:mm:ss");
          break;
        case "month":
          this.getBaseChannelList(9);
          this.dateType = "month";
          this.initDateTime("yyyy-MM-dd HH:mm:ss");
          break;
        case "minute":
          this.getBaseChannelList(14);
          this.dateType="datetime";
          this.dateFormat = "yyyy-MM-dd HH:mm:ss";
          this.initDateTime("yyyy-MM-dd HH:mm:00");
          break;
      }
    },
    exportExcel() {
      // this.$util.exportExcel("站点信息", "#mytable");
      var _this = this;
      var treePath = _this.$store.state.treePath;
      _this.form.aliasName = _this.stationLabelName;
      _this.$api.downloadFile(
          "POST",
          "/analysis/exportExcelHistoryStatistic",
          _this.form,
          function(res) {
            if (res.code == "200") {
            }
          }
      );
    },
    getBaseChannelList(channelCount) {
      var _this = this;
      this.$api.get("/Common/getChannelList", {channelCount:channelCount}, function(res) {
        if (res.code == "0000") {
          _this.channelList = [];
          _this.curChannelList = [];
          _this.channelIds=[];
          if (_this.form.dateType === 'month') {
            _this.channelList = res.data.filter((e) => (e.channelId !== 30 && e.channelId !== 66));
          } else {
            _this.channelList = res.data.filter((e) => e.channelId !== 30);
          }

          _this.channelList.forEach((item) => {
            if (item.channelMap.indexOf("_") != -1) {
              item.prop = item.channelMap.split("_")[0].toLowerCase();
            } else {
              item.prop = item.channelMap.toLowerCase();
            }
            if (item.channelId !== 1 && item.channelId !== 3 && item.channelId !== 5 && item.channelId !== 7 && item.channelId !== 27 && item.channelId !== 31) {
              _this.channelIds.push(item.channelId);
              _this.curChannelList.push(item);
            }
          });
        }
      });
     /* _this.$nextTick(()=>{
        this.$refs.mytable.doLayout()
      });*/
    },
    //查询表格
    loadData() {
      var _this = this;
      _this.tableHeight = this.$refs.container.clientHeight;
      if (!_this.form.startTime || !_this.form.endTime) {
        _this.$message.warning("时间区间不能为空！");
        return;
      }
      let start = new Date(_this.form.startTime).getTime();
      let end = new Date(_this.form.endTime).getTime();
      if (end >= start) {
        if (end - start > 7 * 24 * 60 * 60 * 1000 && _this.form.dateType === 'minute') {
          _this.$message.warning("分钟时间区间不能超过7天！");
          return
        }else if (end-start>365*24*60*60*1000 && _this.form.dateType === 'month') {
          _this.$message.warning("时间区间不能超过365天！");
          return;
        }else if (end-start>30*24*60*60*1000 && _this.form.dateType !== 'month') {
          _this.$message.warning("时间区间不能大于30天！");
          return;
        }
        _this.$refs.mytable.reload();
      } else {
        _this.$message.warning("开始时间不能大于结束时间！");
        return
      }
    },
    //调用表格查询接口
    query(stationList) {
      this.form.stationIds = stationList;
      this.loadData();
    },
    initDateTime(fomart) {
      if (this.form.dateType === 'minute') {
        this.form.startTime = this.$util.formatDate24(
            new Date(new Date().getTime()-1*60*60*1000),
            'yyyy-MM-dd HH:mm:00'
        );
      }else if (this.form.dateType === 'hour') {
        this.form.startTime = this.$util.formatDate24(
            new Date(new Date().getTime()),
            'yyyy-MM-dd 00:00:00'
        );
      }else if (this.form.dateType === 'day') {
        this.form.startTime = this.$util.formatDate24(
            new Date(new Date().getTime()),
            'yyyy-MM-01 00:00:00'
        );
      } else {
        this.form.startTime = this.$util.formatDate24(
            new Date(new Date().getTime()),
            'yyyy-01-01 00:00:00'
        );
      }
      this.form.endTime = this.$util.formatDate24(
          new Date(new Date().getTime()),
          fomart
      );
      this.$nextTick(()=>{
        this.loadData();
      })
    },
    toFixedValue(row, column, cellValue) {
      let labelValue = cellValue;
      this.channelList.forEach((item) => {
        if (item.channelMap.indexOf("_") != -1) {
          item.channelMap1 = item.channelMap.split("_")[0].toLowerCase();
        } else {
          item.channelMap1 = item.channelMap.toLowerCase();
        }
      });
      this.channelList.map((item) => {
        if (item.channelMap1 === column.property) {
          labelValue =
              cellValue || cellValue === 0
                  ? cellValue.toFixed(item.digitNum)
                  : "";
        }
      });
      return labelValue;
    },
    getHeaderCellStyle({ row, column, rowIndex, columnIndex }) {
      let color = "#EBF3FE";
      if (rowIndex === 0) {
        return `background:${color};`;
      }
    },
    channelChange(val) {
      let that = this;
      that.curChannelList = [];
      val.forEach(item=>{
        that.channelList.map((v)=>{
          if (v.channelId === item) {
            that.curChannelList.push(v);
          }
        })
      })
      that.$nextTick(()=>{
        that.loadData();
      })
    },
  },
  //控制表格高度
  mounted() {
    this.$nextTick(()=>{
      this.loadData();
    })
   /* this.$nextTick(function() {
      this.tableHeight = this.$refs.container.clientHeight;
    });*/
  },
  created() {
    //this.initDateTime(this.dateFormat);
    this.getBaseChannelList();
    //this.loadAllApiColor();
  },
  watch: {}
};
</script>
<style lang="less" scoped>
.edit-channel-box {
  display: flex;
  flex-direction: column;
}
.channel-filter {
  width: 100%;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}
.channel-form {
  box-sizing: border-box;
  padding: 15px 0;
  height: 0;
  width: 100%;
  flex: 1;
}
/deep/.channel-dialog .el-dialog .el-dialog__body {
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  padding: 20px;
}
.help {
  float: right;
  font-size: 20px;
  color: #e6a23c;
  cursor: pointer;
}
.container {
  height: 100%;
  width: 100%;
}
.el-table {
  overflow: visible !important;
}
/deep/.el-table--medium th {
  padding: 3px 0 !important;
}
/deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner{
  background-color: white;
  border-color: #DCDFE6;
}
/deep/.el-tag.el-tag--info{
  color: #000000;
}
/deep/.el-tag.el-tag--info .el-tag__close {
  color: #000000;
}
/deep/.el-form--inline .el-form-item{
  margin-right: 5px;
}
</style>
